export default __webpack_public_path__ + "static/media/049-kitchen utensils.3f5c617b.svg";